var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"filter"},[_vm._t("iconBefore"),_vm._t("label"),_vm._t("iconAfter"),_vm._t("options"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }